import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import catShiftAction from '~/modules/master/redux/actions/cat-shift'

const useCatShift = () => {
  const data = useSelector((state) => get(state, 'master.catShift'))

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(catShiftAction, dispatch),
    [dispatch],
  )
  return {
    actions,
    data,
  }
}

export default useCatShift
